import { __assign, __awaiter, __generator } from "tslib";
import { evaluateTargeting as evaluateTargetingPackage } from '@amplitude/targeting';
import { targetingIDBStore } from './targeting-idb-store';
export var evaluateTargetingAndStore = function (_a) {
    var sessionId = _a.sessionId, targetingConfig = _a.targetingConfig, loggerProvider = _a.loggerProvider, apiKey = _a.apiKey, targetingParams = _a.targetingParams;
    return __awaiter(void 0, void 0, void 0, function () {
        var idbTargetingMatch, sessionTargetingMatch, targetingResult, err_1, knownError;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, targetingIDBStore.clearStoreOfOldSessions({
                        loggerProvider: loggerProvider,
                        apiKey: apiKey,
                        currentSessionId: sessionId,
                    })];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, targetingIDBStore.getTargetingMatchForSession({
                            loggerProvider: loggerProvider,
                            apiKey: apiKey,
                            sessionId: sessionId,
                        })];
                case 2:
                    idbTargetingMatch = _b.sent();
                    if (idbTargetingMatch === true) {
                        return [2 /*return*/, true];
                    }
                    sessionTargetingMatch = true;
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, evaluateTargetingPackage(__assign(__assign({}, targetingParams), { flag: targetingConfig, sessionId: sessionId, apiKey: apiKey, loggerProvider: loggerProvider }))];
                case 4:
                    targetingResult = _b.sent();
                    if (targetingResult && targetingResult.sr_targeting_config) {
                        sessionTargetingMatch = targetingResult.sr_targeting_config.key === 'on';
                    }
                    void targetingIDBStore.storeTargetingMatchForSession({
                        loggerProvider: loggerProvider,
                        apiKey: apiKey,
                        sessionId: sessionId,
                        targetingMatch: sessionTargetingMatch,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _b.sent();
                    knownError = err_1;
                    loggerProvider.warn(knownError.message);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, sessionTargetingMatch];
            }
        });
    });
};
